import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { typingDuration, useTypedText } from './useDemoPlayer';
import { DEMO_SAENGGIBU, DEMO_STYLE } from './demoFixtures';

const S = DEMO_STYLE;

// 0 예전 생기부 붙여넣기 → 1 버튼 누름 → 2 문체 읽는 중 → 3 읽은 스타일 → 4 다음 생성 결과 → 5(완성)
const STEPS = [typingDuration(S.pasted, 4, 18), 550, 1100, 1700, 1400];

const StyleApplyDemo = ({ surface = 'my_style', title = '내 스타일', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'my_style', autoStart });
  const { phase, done, paused } = player;
  const pasted = useTypedText(S.pasted, { active: phase === 0, complete: phase > 0, paused, charsPerTick: 4, tickMs: 18 });

  return (
    <DemoFrame title={title} player={player}>
      <div className="wqdemo-sg-setup">
        <div>
          <span className="wqdemo-label">예전에 쓴 생기부를 붙여넣어 주세요</span>
          <div className="wqdemo-input">
            {pasted}
            {phase === 0 && <span className="wqdemo-cursor" />}
          </div>
        </div>
        {phase < 3 && (
          <div className="wqdemo-row-end">
            <span className={`wqdemo-btn is-primary${phase === 1 ? ' is-pressed' : ''}`}>
              {phase === 2 ? '문체 읽는 중…' : '내 스타일로 저장'}
            </span>
          </div>
        )}
      </div>

      {phase >= 3 && (
        <div className="wqdemo-style-fields wqdemo-in">
          <p className="wqdemo-style-head">이렇게 읽었어요</p>
          <dl>
            {S.fields.map((f) => (
              <div key={f.label} className="wqdemo-style-field">
                <dt>{f.label}</dt>
                <dd>{f.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      )}

      {phase >= 4 && (
        <div className="wqdemo-sg-card wqdemo-in">
          <div className="wqdemo-sg-card-head">
            <span>
              {DEMO_SAENGGIBU.student} · {DEMO_SAENGGIBU.subject} {DEMO_SAENGGIBU.category}
            </span>
            <span className="wqdemo-style-applied">내 스타일 적용</span>
          </div>
          <div className="wqdemo-sg-card-body">
            {S.result.map((seg) =>
              seg.style ? (
                <mark key={seg.t} className={`wqdemo-style-hl${done ? ' is-on' : ''}`}>{seg.t}</mark>
              ) : (
                <span key={seg.t}>{seg.t}</span>
              ),
            )}
          </div>
        </div>
      )}
    </DemoFrame>
  );
};

export default StyleApplyDemo;
